import React from 'react';
import HeroSection from '../components/HeroSection';
import PopularRoutes from '../components/PopularRoutes';
import HowItWorks from '../components/HowItWorks';
import FeaturesSection from '../components/FeaturesSection';
import Testimonials from '../components/Testimonials';
import CtaBanner from '../components/CtaBanner';
import SEO from '../components/SEO';

const homeJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '1ClickBooking',
  url: 'https://1clickbooking.us',
  description: 'Book flights in one click. Compare fares across all major US airlines instantly with no hidden fees.',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://1clickbooking.us/flights?origin={origin}&destination={destination}&date={date}&adults=1',
    'query-input': 'required name=origin required name=destination required name=date',
  },
};

export default function HomePage() {
  return (
    <div>
      <SEO
        canonical="/"
        description="Book flights in one click. Compare fares across Delta, American, United, JetBlue and more. No hidden fees, instant confirmation, 24/7 support."
        keywords="cheap flights, book flights online, flight deals, one click booking, domestic flights USA, compare airline prices, best flight fares"
        jsonLd={homeJsonLd}
      />
      <HeroSection />
      <PopularRoutes />
      <HowItWorks />
      <FeaturesSection />
      <Testimonials />
      <CtaBanner />
    </div>
  );
}
